import React from "react";
import { Link, useLocation } from "react-router-dom";
import { cerrarSidebar } from "./sidebarUtils";

const NavItems = ({
  isMenuExpanded,
  handleMenuToggle,
  items,
  activeUrl = null
}) => {
  const location = useLocation();
  const currentPath = activeUrl || location.pathname;

  const hasActiveSubItem = (item) => {
    return item.urls?.some(subItem => currentPath === subItem.url) || false;
  };

  return items.map((item, index) => {
    const isExpanded = isMenuExpanded(index);
    const hasActiveSub = hasActiveSubItem(item);

    return (
      <li key={index} className={`nav-item ${isExpanded ? "menu-open" : ""}`}>
        <Link
          to="#"
          className={`nav-link ${hasActiveSub ? "active" : ""}`}
          onClick={(e) => {
            e.preventDefault();
            handleMenuToggle(index);
          }}
        >
          <i className={`nav-icon mx-2 ${item.icono}`} />
          <p className="mb-0">
            {item.nombre}
            <i className="fas fa-angle-left right ml-2" />
          </p>
        </Link>
        <ul className="nav nav-treeview">
          {(item.urls || []).map((subItem, subIndex) => {
            const isActive = currentPath === subItem.url;
            return (
              <li key={subIndex} className="nav-item">
                <Link
                  to={subItem.url}
                  className={`nav-link ${isActive ? "active" : ""}`}
                  onClick={() => {
                    if (window.innerWidth <= 1024 || document.body.classList.contains("sidebar-open")) {
                      cerrarSidebar();
                    }
                  }}
                >
                  <i className={`nav-icon mx-2 ${isActive ? "fa-solid fa-check" : "far fa-circle"}`} />
                  <p className="mb-0">{subItem.nombre}</p>
                </Link>
              </li>
            );
          })}
        </ul>
      </li>
    );
  });
};

export default NavItems;
